require('./helpers/bundle-manifest').register(JSON.parse("{\"h00hi\":\"index.4db0cf10.js\",\"2Ar03\":\"screenshot.8c0ffe24.png\"}"));